import styled from 'styled-components';
import { Typography } from '../../../../../components/display/Typography';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const BudgetCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.xl};
  padding: ${({ theme }) => theme.spacing.xxl};
  background-color: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila ROIS */
  border-radius: ${({ theme }) => theme.borderRadius.md};

  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;

export const TitleTagContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.xl};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.spacing.m};
  }
`;

export const Title = styled(Typography)`
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.M};
  }
`;

export const RowContainer = styled.div`
  display: flex;
  padding-bottom: ${({ theme }) => theme.spacing.xl};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const RowContainerLast = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.xl};
  padding: 0;
  border: none;
`;

export const ColumnsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xl};
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxs};
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs};
`;

export const ColumnTitleContainer = styled.div``;

export const SmallTitle = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const RowSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};
  overflow: hidden;
`;

export const RowSubContainerLeft = styled(RowSubContainer)`
  padding: 0 14rem 0 0;
  border-right: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  flex-shrink: 0;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: 0 0 ${({ theme }) => theme.spacing.xl} 0;
    border-right: none;
    border-bottom: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  }
`;

export const RowSubContainerRight = styled(RowSubContainer)`
  padding: 0 0 0 14rem;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.xl} 0 0 0;
  }
`;

export const ContainerButtons = styled.div`
  display: flex;
  align-self: end;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const CategoryIndicator = styled.div<{ color: string }>`
  width: 1.2rem;
  height: 1.2rem;
  background-color: ${({ color }) => color};
  border-radius: 0.2rem;
  flex-shrink: 0;
`;
